import { isArabicUi } from "@/shared/config/arabicUi";

/**
 * «История баллов» тренировок — /{lang}/account/points-history (неделя:
 * ?week=YYYY-Www). Владелец хочет проверять, как считаются баллы, поэтому
 * страница открыта всем вошедшим. "admins" — только администраторам (с учётом
 * «смотреть как пользователь»): одна строка здесь закрывает и страницу, и все
 * входы на неё («Прогресс и лига» → «Баллы» и её «···», свои числа баллов
 * «Тренировок» — OwnPointsLink).
 */
export type PointsHistoryAudience = "all" | "admins";

export const POINTS_HISTORY_FOR: PointsHistoryAudience = "all";

/** Адрес страницы без языка. */
export const POINTS_HISTORY_PATH = "/account/points-history";

/** Видна ли страница этому человеку. */
export const pointsHistoryOpen = (isAdmin: boolean, audience: PointsHistoryAudience = POINTS_HISTORY_FOR): boolean =>
    audience === "all" || isAdmin;

/** Адрес страницы на языке сайта; с неделей — экран недели. */
export const pointsHistoryHref = (lang: string, week?: string | null): string =>
    `/${lang || "ru"}${POINTS_HISTORY_PATH}${week ? `?week=${encodeURIComponent(week)}` : ""}`;

/**
 * Имя страницы — подпись своего числа баллов, которое на неё ведёт (для чтения с экрана):
 * те же слова, что заголовок страницы (PointsHistoryPage texts.title). /ar — по-арабски только
 * при включённом арабском интерфейсе, иначе английский, как весь сайт там.
 */
const LABEL: Record<string, string> = {
    ru: "История баллов",
    en: "Points history",
    de: "Punkteverlauf",
    es: "Historial de puntos",
    cn: "积分记录",
    ar: "سجل النقاط",
};

export const pointsHistoryLabel = (lang: string | null | undefined): string => {
    const l = String(lang || "").toLowerCase();
    if (l === "zh") return LABEL.cn;
    if (l === "ar") return isArabicUi(l) ? LABEL.ar : LABEL.en;
    return LABEL[l] ?? LABEL.en;
};
